import React from "react";
import { FORMAT_LIST } from "../../utils/other-component";
import BlueHeading from "../other/common/BlueHeading";
import leftLeafImg from "../../assets/images/webp/other/left-leaf-img.webp";
import CustomButton from "../other/common/CustomButton";

const FormatPricing = () => {
  return (
    <>
      <div className="relative px-4 py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-14">
        <img
          src={leftLeafImg}
          alt="leaf"
          width={86}
          height={179}
          className="absolute top-0 left-0  object-contain max-sm:max-w-10"
        />
        <div className="flex items-center justify-center flex-col relative z-10">
          <BlueHeading text="Formats & Pricing" />
          <h2 className="text-[#001A3D] text-[64px] max-w-[734px] mx-auto max-xl:text-5xl max-lg:text-4xl max-md:text-3xl font-bold ff-jakarta leading-[120%] pb-[50px] max-xl:pb-10 text-center">
            Available Now in Your Favorite Format
          </h2>
        </div>
        <div className="flex items-center gap-3 sm:gap-5 max-w-[1140px] mx-auto flex-wrap  justify-center">
          {FORMAT_LIST.map((item, index) => (
            <div
              key={index}
              className="border border-solid border-[#241DB64D] bg-[#251db61c] format-box-bg w-full max-lg:max-w-[340px] max-lg:h-[360px] max-w-[364px] h-[375px] rounded-2xl flex flex-col items-center justify-center group transition-all ease-linear duration-300 hover:!bg-[#241DB6] hover:!text-white"
            >
              <img
                src={item.img}
                alt="format-img"
                width={300}
                height={209}
                className={`${
                  index === 1
                    ? "max-w-[228px] h-[228px]"
                    : index === 2
                    ? "max-w-[198px] h-[206px]"
                    : "max-w-[300px] h-[209px]"
                } pointer-events-none mx-auto max-lg:max-w-[198px] max-lg:h-[200px]`}
              />
              <h3 className="font-bold text-[40px] max-md:text-3xl pt-2 leading-[130%] text-center text-[#001A3D] group-hover:text-white">
                {item.title}
              </h3>
              <p className="text-lg font-normal leading-[150%] text-center text-[#001A3D] pb-[28px] group-hover:text-white pt-2">
                Hindi & English
              </p>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center">
          <CustomButton
            text="Buy Now at Special Launch Price"
            myClass="mt-10 mx-auto"
          />
        </div>
      </div>
    </>
  );
};

export default FormatPricing;
